import { batch } from "react-redux";
import SelectionState from "state/selections/SelectionState";
import {
  selectSelectedGroupTypeValue,
  selectSelectedGroupValues,
  selectSelectedEntityIds,
  selectSelectedAsOfDate,
  selectSelectedAsOfDateStart,
  selectModeValue,
  selectSelectedIsDisplayRgl,
  selectSelectedLocalCurrencyFiltervalues,
  selectSelectedOfferingMarketsValues,
  selectSelectedTransactionCodeFiltervalues,
  selectSelectedTransactionEffectFiltervalues,
  selectSelectedTickerFiltervalues,
  selectSelectedIsShowCanceledTrades,
  selectSelectedReplaceMajorsWithMinors,
  selectSelectedSecurityIdsValues,
  selectSelectedInstrumentTypesValues,
  selectSelectedInstrumentTypeIncludeOptionValue,
  selectSelectedMsaaOneValues,
  selectSelectedMsaaBucketCodes,
  selectSelectedTraderIds
} from "state/selections/selectors";
import { requestTradeHistoryData} from 'state/analytics/actions';
import {selectDefinitions as selectBetaDefinitions  } from 'state/betas/selectors';
import {selectDefinitions as selectHoldingDefinitions  } from 'state/holdingAttributes/selectors';
export const TOGGLE_DRAWER = 'app/TOGGLE_DRAWER';
export const toggleDrawer = (opts = {}) => ({
  type: TOGGLE_DRAWER,
  override: opts.override
});

export const SET_APP_TITLE = 'app/SET_APP_TITLE';
export const setAppTitle = appTitle => ({
  type: SET_APP_TITLE,
  appTitle
});

export const SET_APP_DECIMAL = 'app/SET_APP_DECIMAL';
export const setAppDecimal = appDecimal => ({
  type: SET_APP_DECIMAL,
  appDecimal
});

export const SET_USERNAME = 'app/SET_USERNAME';
export const setUsername = username => ({
  type: SET_USERNAME,
  username
});

export const SET_DISPLAY_MAJOR_MINOR_ON_TITLE = 'app/SET_DISPLAY_MAJOR_MINOR_ON_TITLE';
export const setDisplayMajorMinorOnTitle = displayMajorMinotOnTitle => ({
  type: SET_DISPLAY_MAJOR_MINOR_ON_TITLE,
  displayMajorMinotOnTitle
});

export const SET_BANDED_ROWS = 'app/SET_BANDED_ROWS';
export const setBandedRows = bandedRows => ({
  type: SET_BANDED_ROWS,
  bandedRows
});

export const SET_GRID_VERTICAL_LINES = 'app/SET_GRID_VERTICAL_LINES';
export const setGridVerticalLines = gridVerticalLines => ({
  type: SET_GRID_VERTICAL_LINES,
  gridVerticalLines
});

export const SET_GRID_FONT_SIZE = 'app/SET_GRID_FONT_SIZE';
export const setGridFontSize = gridFontSize => ({
  type: SET_GRID_FONT_SIZE,
  gridFontSize
});

export const SET_GRID_ROW_HEIGHT = 'app/SET_GRID_ROW_HEIGHT';
export const setGridRowHeight = gridRowHeight => ({
  type: SET_GRID_ROW_HEIGHT,
  gridRowHeight
});

export const SET_HIDE_GRID_SIDE_BAR = 'app/SET_HIDE_GRID_SIDE_BAR';
export const setHideGridSideBar = (value) => ({
  type: SET_HIDE_GRID_SIDE_BAR,
  value,
});

export const SET_NO_ACCOUNT_FLAG = 'App/SET_NO_ACCOUNT_FLAG';
export const setNoAccountFlag = (noAccountLoad) => ({
  type: SET_NO_ACCOUNT_FLAG,
  noAccountLoad,
});


export const startRequests = () => {
  return (dispatch, getState) =>{
    batch(async()=>{
      const state = getState();
      const groupType = selectSelectedGroupTypeValue(SelectionState.COMMITTED)(state)
      const groups = selectSelectedGroupValues(SelectionState.COMMITTED)(state)
      const asOfDate = selectSelectedAsOfDate(SelectionState.COMMITTED)(state)
      const asOfDateStart =  selectSelectedAsOfDateStart(SelectionState.COMMITTED)(state)
      const entityIds = selectSelectedEntityIds(SelectionState.COMMITTED)(state)
      const mode = selectModeValue(SelectionState.COMMITTED)(state)
      const showRealizedGl = selectSelectedIsDisplayRgl(SelectionState.COMMITTED)(state)
      const isShowCanceledTrades = selectSelectedIsShowCanceledTrades(SelectionState.COMMITTED)(state)
      const replaceMajorsWithMinors = selectSelectedReplaceMajorsWithMinors(SelectionState.COMMITTED)(state)
    //  const majorMinor = "BOTH"
      const localCurrencyCodes = selectSelectedLocalCurrencyFiltervalues(SelectionState.COMMITTED)(state)
      const offeringMarkets = selectSelectedOfferingMarketsValues(SelectionState.COMMITTED)(state)
      const transactionCodes = selectSelectedTransactionCodeFiltervalues(SelectionState.COMMITTED)(state)
      const transactionEffects = selectSelectedTransactionEffectFiltervalues(SelectionState.COMMITTED)(state)
      const tickers =   selectSelectedTickerFiltervalues(SelectionState.COMMITTED)(state)
      const betaDefinitions = selectBetaDefinitions(SelectionState.COMMITTED)(state);
      const holingsDefinitions = selectHoldingDefinitions(SelectionState.COMMITTED)(state);
      const instrumentTypes = selectSelectedInstrumentTypesValues(SelectionState.COMMITTED)(state);
      const instrumentTypesIncludeOption = selectSelectedInstrumentTypeIncludeOptionValue(SelectionState.COMMITTED)(state);
      const absMsaaSectors = selectSelectedMsaaOneValues(SelectionState.COMMITTED)(state);
      const msaaBucketCodes = selectSelectedMsaaBucketCodes(SelectionState.COMMITTED)(state);
      const traderIds = selectSelectedTraderIds(SelectionState.COMMITTED)(state);
      const betaIds = [...new Set(betaDefinitions.map(({betaId}) => betaId))] 
      const covar = [...new Set(betaDefinitions.map(({covarianceType}) => covarianceType))]
      const holdings = [...new Set(holingsDefinitions.map(({attribute}) => attribute))]

      const securityIds = selectSelectedSecurityIdsValues(SelectionState.COMMITTED)(state);

      console.log("***Starting requests for: ")
      console.log("groupType: " + groupType)
      console.log("groups: " + groups)
      console.log("asOfDate: " + asOfDate)
      console.log("asOfDateStart: " + asOfDateStart)
      console.log("entityIds: " + entityIds)
      console.log("replaceMajorsWithMinors: " + replaceMajorsWithMinors)
      console.log("mode: " + mode)
      // console.log("majorMinor: " + majorMinor)
      console.log("showRealizedGl: " + showRealizedGl)
      console.log("localCurrencyCodes: " + localCurrencyCodes)
      console.log("offeringMarkets: " + offeringMarkets)
      console.log("transactionCodes: " + transactionCodes)
      console.log("transactionCodes: " + transactionEffects)
      console.log("tickers: " + tickers)
      console.log("isShowCanceledTrades: " + isShowCanceledTrades)
      console.log("betaIds: " + betaIds)
      console.log("covar: " + covar)
      console.log("holdings: " + holdings)
      console.log("securityIds: " + securityIds)
      console.log("instrumentTypes: " + instrumentTypes)
      console.log("absMsaaSectors: " + absMsaaSectors)
      console.log("msaaBucketCodes: " + msaaBucketCodes)
      console.log("traderIds: " + traderIds)
      console.log("instrumentTypesIncludeOption: " + instrumentTypesIncludeOption)
      if(mode==="ENTITIES" && (entityIds === null || entityIds?.length === 0)){
        // Do not dispatch requestes
        // There was a requirement to stop Users from making requests for ALL entities
      } else {
      dispatch(
        requestTradeHistoryData({
          groupType,
          groups,
          asOfDate,
          asOfDateStart,
          entityIds,
          mode,
         // majorMinor,
         replaceMajorsWithMinors,
          showRealizedGl,
          localCurrencyCodes,
          offeringMarkets,
          transactionCodes,
          transactionEffects,
          tickers,
          isShowCanceledTrades,
          betaIds,
          covar,
          holdings,
          securityIds,
          instrumentTypes,
          instrumentTypesIncludeOption,
          absMsaaSectors,
          msaaBucketCodes,
          traderIds
        })
      );
      }
    })
  }
}
